import React from 'react';
import PropTypes from 'prop-types';
import { CTA, Image } from '../../../components';
import { isValidArray } from '../../utilities/validations';
import { classNames } from '@pella/sash-framework';

const FinancingBlock = ({ data, view, className }) => {
	const classes = classNames({
		'grid bg-white p-4': true,
		'grid-cols-1 items-center md:grid-cols-[1fr_auto]': !view,
		'grid-cols-1 sm:grid-cols-[200px_1fr] sm:gap-x-6 xl:gap-x-4 items-center mt-4': view === 'wells-fargo',
		'grid-cols-1 md:grid-cols-[1fr_auto] md:items-center md:gap-x-4 xl:grid-cols-1 xl:items-start mt-4': view === 'service-now',
		[className]: className,
	});

	const imageClasses = classNames({
		'mb-4': !view,
		'col-start-1 row-start-1 sm:row-span-5 mb-4 sm:mb-0 text-center': view === 'wells-fargo',
		'col-start-1 row-start-1 mb-3 xl:mb-4 md:mb-2': view === 'service-now',
	});

	const headingClasses = classNames({
		'text-h3': true,
		'!mb-3 sm:!mb-4 col-start-1 sm:col-start-2 row-start-2': view === 'wells-fargo',
		'col-start-1 row-start-2 !mb-3 md:!mb-2 xl:!mb-4': view === 'service-now',
	});

	const subheadingClasses = classNames({
		'text-body-2 text-pretty': true,
		'mb-4 sm:mb-0': !view,
		'col-start-1 row-start-3 sm:col-start-2 mb-4': view === 'wells-fargo',
		'col-start-1 row-start-3 mb-3 md:mb-2 xl:mb-4': view === 'service-now',
	});

	const ctaClasses = classNames({
		'text-body-2 text-pretty col-start-1 row-start-4': true,
		'sm:col-start-2 sm:row-span-3 sm:row-start-1 sm:ml-4': !view,
		'sm:col-start-2': view === 'wells-fargo',
		'md:col-start-2 md:row-start-1 md:row-span-3 xl:col-start-1 xl:row-start-4': view === 'service-now',
	});

	return (
		<div className={classes}>
			{data?.file?.url && (
				<div className={imageClasses}>
					<Image data={{ image: data.file }} />
				</div>
			)}

			{data?.heading && (
				<h2
					className={headingClasses}
					dangerouslySetInnerHTML={{ __html: data.heading }}
				/>
			)}

			{data?.subheading && (
				<div
					className={subheadingClasses}
					dangerouslySetInnerHTML={{ __html: data.subheading }}
				/>
			)}

			<div className={ctaClasses}>
				{isValidArray(data?.cta) &&
					data.cta.map((cta, index) => (
						<CTA
							key={index}
							data={cta}
							size='sm'
						/>
					))}
			</div>
		</div>
	);
};

FinancingBlock.propTypes = {
	data: PropTypes.object,
	view: PropTypes.string,
	className: PropTypes.string,
};

export default FinancingBlock;
